import React, { ComponentPropsWithoutRef } from 'react';
import { TableCell, Typography } from '@rbx/ui';

type MarkdownTableCellProps = ComponentPropsWithoutRef<'th'> & {
  tableCellStyle?: React.CSSProperties;
};

export default function MarkdownTableCell({
  align,
  children,
  tableCellStyle,
  ...otherProps
}: MarkdownTableCellProps) {
  let textAlign;

  if (align === 'left' || align === 'center' || align === 'right') {
    textAlign = align;
  }
  return (
    <TableCell {...otherProps} align={textAlign} style={tableCellStyle}>
      <Typography variant='body1' style={tableCellStyle}>
        {children}
      </Typography>
    </TableCell>
  );
}
